export const initialise = () => {
    removeTabIndex()
    menus()
}

const removeTabIndex = () => {
    const navigations = document.querySelectorAll<HTMLElement>('.footer .mainNav-widget')
    navigations.forEach((navigation) => {
        const elements = navigation.querySelectorAll<HTMLElement>('[tabindex="-1"]')
        elements.forEach((element) => {
            element.removeAttribute('tabindex')
        })
    })
}

const menus = () => {
    const toggles = document.querySelectorAll<HTMLElement>('.footer__nav .navList li.hasChildren > .icon')

    toggles.forEach((toggle) => {
        const menu = toggle.parentElement?.querySelector('.navList')
        toggle.setAttribute('aria-expanded', 'false')
        menu?.setAttribute('aria-hidden', 'true')

        toggle.addEventListener('click', (event: Event) => {
            toggleNavigation(event, menu)
        })

        toggle.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter' || event.key === ' ') {
                toggleNavigation(event, menu)
            }
        })
    })
}

const toggleNavigation = (event, menu) => {
    const target = event.target as HTMLElement

    if (!target) return
    const isExpanded = target.getAttribute('aria-expanded') === 'true'
    target.setAttribute('aria-expanded', (!isExpanded).toString())
    menu?.setAttribute('aria-hidden', isExpanded.toString())
}
